
import React from 'react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'full' | 'icon';
}

const Logo: React.FC<LogoProps> = ({ size = 'md', variant = 'full' }) => {
  const sizeClass = {
    sm: 'h-8',
    md: 'h-10',
    lg: 'h-12',
  }[size];

  return (
    <div className={`flex items-center ${variant === 'full' ? 'space-x-2' : ''}`}>
      <div className={`${sizeClass} aspect-square bg-gradient-to-br from-primary-400 to-primary-600 rounded-xl flex items-center justify-center text-white overflow-hidden`}>
        <svg className="w-2/3 h-2/3" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 4L4 8L12 12L20 8L12 4Z" fill="white" />
          <path d="M4 12L12 16L20 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M4 16L12 20L20 16" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
      
      {variant === 'full' && (
        <div className="font-sora font-bold text-xl md:text-2xl">
          <span className="text-primary-600">Fund</span>
          <span className="text-text-secondary">OR</span>
          <span className="text-accent-500">Fling</span>
        </div>
      )}
    </div>
  );
};

export default Logo;
